function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $dbcf4b4d170a8f34$exports = {};
var $16f4c57bdee1fbda$exports = {};

$parcel$export($16f4c57bdee1fbda$exports, "KeyToNoteNumber", () => $16f4c57bdee1fbda$export$4c08613943e86cca);
class $16f4c57bdee1fbda$export$4c08613943e86cca {
    static QWERTY = new Map([
        // Octave 1
        [
            "z",
            0
        ],
        [
            ",",
            1
        ],
        [
            "x",
            2
        ],
        [
            ".",
            3
        ],
        [
            "c",
            4
        ],
        [
            "v",
            5
        ],
        [
            "k",
            6
        ],
        [
            "b",
            7
        ],
        [
            "l",
            8
        ],
        [
            "n",
            9
        ],
        [
            ";",
            10
        ],
        [
            "m",
            11
        ],
        // Octave 2
        [
            "a",
            12
        ],
        [
            "i",
            13
        ],
        [
            "s",
            14
        ],
        [
            "o",
            15
        ],
        [
            "d",
            16
        ],
        [
            "f",
            17
        ],
        [
            "p",
            18
        ],
        [
            "g",
            19
        ],
        [
            "[",
            20
        ],
        [
            "h",
            21
        ],
        [
            "]",
            22
        ],
        [
            "j",
            23
        ],
        // Octave 3
        [
            "q",
            24
        ],
        [
            "8",
            25
        ],
        [
            "w",
            26
        ],
        [
            "9",
            27
        ],
        [
            "e",
            28
        ],
        [
            "r",
            29
        ],
        [
            "0",
            30
        ],
        [
            "t",
            31
        ],
        [
            "-",
            32
        ],
        [
            "y",
            33
        ],
        [
            "=",
            34
        ],
        [
            "u",
            35
        ],
        // Octave 4
        [
            "1",
            36
        ],
        [
            "/",
            37
        ],
        [
            "2",
            38
        ],
        [
            "'",
            39
        ],
        [
            "3",
            40
        ],
        [
            "4",
            41
        ],
        [
            "\\",
            42
        ],
        [
            "5",
            43
        ],
        [
            "Delete",
            44
        ],
        [
            "6",
            45
        ],
        [
            "Insert",
            46
        ],
        [
            "7",
            47
        ]
    ]);
}


var $4750f8427600f904$exports = {};

$parcel$export($4750f8427600f904$exports, "PianoApp", () => $4750f8427600f904$export$ff5339764f77153d);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $e5ed8027d647799b$var$t;
const $e5ed8027d647799b$var$i = window, $e5ed8027d647799b$var$s = $e5ed8027d647799b$var$i.trustedTypes, $e5ed8027d647799b$var$e = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e5ed8027d647799b$var$o = "$lit$", $e5ed8027d647799b$var$n = `lit$${(Math.random() + "").slice(9)}$`, $e5ed8027d647799b$var$l = "?" + $e5ed8027d647799b$var$n, $e5ed8027d647799b$var$h = `<${$e5ed8027d647799b$var$l}>`, $e5ed8027d647799b$var$r = document, $e5ed8027d647799b$var$u = ()=>$e5ed8027d647799b$var$r.createComment(""), $e5ed8027d647799b$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e5ed8027d647799b$var$c = Array.isArray, $e5ed8027d647799b$var$v = (t)=>$e5ed8027d647799b$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $e5ed8027d647799b$var$a = "[ 	\n\f\r]", $e5ed8027d647799b$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e5ed8027d647799b$var$_ = /-->/g, $e5ed8027d647799b$var$m = />/g, $e5ed8027d647799b$var$p = RegExp(`>|${$e5ed8027d647799b$var$a}(?:([^\\s"'>=/]+)(${$e5ed8027d647799b$var$a}*=${$e5ed8027d647799b$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e5ed8027d647799b$var$g = /'/g, $e5ed8027d647799b$var$$ = /"/g, $e5ed8027d647799b$var$y = /^(?:script|style|textarea|title)$/i, $e5ed8027d647799b$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e5ed8027d647799b$export$c0bb0b647f701bb5 = $e5ed8027d647799b$var$w(1), $e5ed8027d647799b$export$7ed1367e7fa1ad68 = $e5ed8027d647799b$var$w(2), $e5ed8027d647799b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e5ed8027d647799b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e5ed8027d647799b$var$E = new WeakMap, $e5ed8027d647799b$var$C = $e5ed8027d647799b$var$r.createTreeWalker($e5ed8027d647799b$var$r, 129, null, !1);
function $e5ed8027d647799b$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e5ed8027d647799b$var$e ? $e5ed8027d647799b$var$e.createHTML(i) : i;
}
const $e5ed8027d647799b$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $e5ed8027d647799b$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $e5ed8027d647799b$var$f ? "!--" === c[1] ? u = $e5ed8027d647799b$var$_ : void 0 !== c[1] ? u = $e5ed8027d647799b$var$m : void 0 !== c[2] ? ($e5ed8027d647799b$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $e5ed8027d647799b$var$p) : void 0 !== c[3] && (u = $e5ed8027d647799b$var$p) : u === $e5ed8027d647799b$var$p ? ">" === c[0] ? (u = null != l ? l : $e5ed8027d647799b$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $e5ed8027d647799b$var$p : '"' === c[3] ? $e5ed8027d647799b$var$$ : $e5ed8027d647799b$var$g) : u === $e5ed8027d647799b$var$$ || u === $e5ed8027d647799b$var$g ? u = $e5ed8027d647799b$var$p : u === $e5ed8027d647799b$var$_ || u === $e5ed8027d647799b$var$m ? u = $e5ed8027d647799b$var$f : (u = $e5ed8027d647799b$var$p, l = void 0);
        const w = u === $e5ed8027d647799b$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $e5ed8027d647799b$var$f ? s + $e5ed8027d647799b$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $e5ed8027d647799b$var$o + s.slice(v) + $e5ed8027d647799b$var$n + w) : s + $e5ed8027d647799b$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $e5ed8027d647799b$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $e5ed8027d647799b$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $e5ed8027d647799b$var$V(t, i);
        if (this.el = $e5ed8027d647799b$var$N.createElement(a, e), $e5ed8027d647799b$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $e5ed8027d647799b$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($e5ed8027d647799b$var$o) || i.startsWith($e5ed8027d647799b$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $e5ed8027d647799b$var$o).split($e5ed8027d647799b$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $e5ed8027d647799b$var$H : "?" === i[1] ? $e5ed8027d647799b$var$L : "@" === i[1] ? $e5ed8027d647799b$var$z : $e5ed8027d647799b$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($e5ed8027d647799b$var$y.test(h.tagName)) {
                    const t = h.textContent.split($e5ed8027d647799b$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $e5ed8027d647799b$var$u()), $e5ed8027d647799b$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $e5ed8027d647799b$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $e5ed8027d647799b$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($e5ed8027d647799b$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $e5ed8027d647799b$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $e5ed8027d647799b$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e5ed8027d647799b$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $e5ed8027d647799b$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $e5ed8027d647799b$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $e5ed8027d647799b$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $e5ed8027d647799b$var$r).importNode(s, !0);
        $e5ed8027d647799b$var$C.currentNode = o;
        let n = $e5ed8027d647799b$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $e5ed8027d647799b$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $e5ed8027d647799b$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $e5ed8027d647799b$var$C.nextNode(), l++);
        }
        return $e5ed8027d647799b$var$C.currentNode = $e5ed8027d647799b$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e5ed8027d647799b$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e5ed8027d647799b$var$S(this, t, i), $e5ed8027d647799b$var$d(t) ? t === $e5ed8027d647799b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && this._$AR(), this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee) : t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $e5ed8027d647799b$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && $e5ed8027d647799b$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($e5ed8027d647799b$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $e5ed8027d647799b$var$N.createElement($e5ed8027d647799b$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $e5ed8027d647799b$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e5ed8027d647799b$var$E.get(t.strings);
        return void 0 === i && $e5ed8027d647799b$var$E.set(t.strings, i = new $e5ed8027d647799b$var$N(t)), i;
    }
    T(t) {
        $e5ed8027d647799b$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $e5ed8027d647799b$var$R(this.k($e5ed8027d647799b$var$u()), this.k($e5ed8027d647799b$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $e5ed8027d647799b$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $e5ed8027d647799b$var$S(this, t, i, 0), n = !$e5ed8027d647799b$var$d(t) || t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $e5ed8027d647799b$var$S(this, e[s + l], i, l), h === $e5ed8027d647799b$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$e5ed8027d647799b$var$d(h) || h !== this._$AH[l]), h === $e5ed8027d647799b$export$45b790e32b2810ee ? t = $e5ed8027d647799b$export$45b790e32b2810ee : t !== $e5ed8027d647799b$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $e5ed8027d647799b$var$H extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e5ed8027d647799b$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $e5ed8027d647799b$var$I = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.emptyScript : "";
class $e5ed8027d647799b$var$L extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $e5ed8027d647799b$var$I) : this.element.removeAttribute(this.name);
    }
}
class $e5ed8027d647799b$var$z extends $e5ed8027d647799b$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $e5ed8027d647799b$var$S(this, t, i, 0)) && void 0 !== s ? s : $e5ed8027d647799b$export$45b790e32b2810ee) === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $e5ed8027d647799b$export$45b790e32b2810ee && e !== $e5ed8027d647799b$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $e5ed8027d647799b$export$45b790e32b2810ee && (e === $e5ed8027d647799b$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e5ed8027d647799b$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e5ed8027d647799b$var$S(this, t);
    }
}
const $e5ed8027d647799b$export$8613d1ca9052b22e = {
    O: $e5ed8027d647799b$var$o,
    P: $e5ed8027d647799b$var$n,
    A: $e5ed8027d647799b$var$l,
    C: 1,
    M: $e5ed8027d647799b$var$V,
    L: $e5ed8027d647799b$var$M,
    D: $e5ed8027d647799b$var$v,
    R: $e5ed8027d647799b$var$S,
    I: $e5ed8027d647799b$var$R,
    V: $e5ed8027d647799b$var$k,
    H: $e5ed8027d647799b$var$L,
    N: $e5ed8027d647799b$var$z,
    U: $e5ed8027d647799b$var$H,
    F: $e5ed8027d647799b$var$Z
}, $e5ed8027d647799b$var$B = $e5ed8027d647799b$var$i.litHtmlPolyfillSupport;
null == $e5ed8027d647799b$var$B || $e5ed8027d647799b$var$B($e5ed8027d647799b$var$N, $e5ed8027d647799b$var$R), (null !== ($e5ed8027d647799b$var$t = $e5ed8027d647799b$var$i.litHtmlVersions) && void 0 !== $e5ed8027d647799b$var$t ? $e5ed8027d647799b$var$t : $e5ed8027d647799b$var$i.litHtmlVersions = []).push("2.7.5");
const $e5ed8027d647799b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $e5ed8027d647799b$var$R(i.insertBefore($e5ed8027d647799b$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};



/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $ead5767561d7cbc1$var$l } = (0, $e5ed8027d647799b$export$8613d1ca9052b22e), $ead5767561d7cbc1$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $ead5767561d7cbc1$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2
}, $ead5767561d7cbc1$export$6b6d145ec2a44ca9 = (o, l)=>void 0 === l ? void 0 !== (null == o ? void 0 : o._$litType$) : (null == o ? void 0 : o._$litType$) === l, $ead5767561d7cbc1$export$2f448fec17d50a3e = (o)=>void 0 !== (null == o ? void 0 : o._$litDirective$), $ead5767561d7cbc1$export$f28e31de6a6eaf32 = (o)=>null == o ? void 0 : o._$litDirective$, $ead5767561d7cbc1$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $ead5767561d7cbc1$var$c = ()=>document.createComment(""), $ead5767561d7cbc1$export$291b2338ad9b0b30 = (o, t, i)=>{
    var n;
    const d = o._$AA.parentNode, v = void 0 === t ? o._$AB : t._$AA;
    if (void 0 === i) {
        const t = d.insertBefore($ead5767561d7cbc1$var$c(), v), n = d.insertBefore($ead5767561d7cbc1$var$c(), v);
        i = new $ead5767561d7cbc1$var$l(t, n, o, o.options);
    } else {
        const l = i._$AB.nextSibling, t = i._$AM, e = t !== o;
        if (e) {
            let l;
            null === (n = i._$AQ) || void 0 === n || n.call(i, o), i._$AM = o, void 0 !== i._$AP && (l = o._$AU) !== t._$AU && i._$AP(l);
        }
        if (l !== v || e) {
            let o = i._$AA;
            for(; o !== l;){
                const l = o.nextSibling;
                d.insertBefore(o, v), o = l;
            }
        }
    }
    return i;
}, $ead5767561d7cbc1$export$cb8bf9562088e9f4 = (o, l, t = o)=>(o._$AI(l, t), o), $ead5767561d7cbc1$var$f = {}, $ead5767561d7cbc1$export$ea70d9dd5965b1c8 = (o, l = $ead5767561d7cbc1$var$f)=>o._$AH = l, $ead5767561d7cbc1$export$59e9bce518cde500 = (o)=>o._$AH, $ead5767561d7cbc1$export$3133b3144bbba267 = (o)=>{
    var l;
    null === (l = o._$AP) || void 0 === l || l.call(o, !1, !0);
    let t = o._$AA;
    const i = o._$AB.nextSibling;
    for(; t !== i;){
        const o = t.nextSibling;
        t.remove(), t = o;
    }
}, $ead5767561d7cbc1$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3baabda811939da5$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $3baabda811939da5$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $3baabda811939da5$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f3bd3fa2e54a33fb$var$s = (i, t)=>{
    var e, o;
    const r = i._$AN;
    if (void 0 === r) return !1;
    for (const i of r)null === (o = (e = i)._$AO) || void 0 === o || o.call(e, t, !1), $f3bd3fa2e54a33fb$var$s(i, t);
    return !0;
}, $f3bd3fa2e54a33fb$var$o = (i)=>{
    let t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === (null == e ? void 0 : e.size));
}, $f3bd3fa2e54a33fb$var$r = (i)=>{
    for(let t; t = i._$AM; i = t){
        let e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), $f3bd3fa2e54a33fb$var$l(t);
    }
};
function $f3bd3fa2e54a33fb$var$n(i) {
    void 0 !== this._$AN ? ($f3bd3fa2e54a33fb$var$o(this), this._$AM = i, $f3bd3fa2e54a33fb$var$r(this)) : this._$AM = i;
}
function $f3bd3fa2e54a33fb$var$h(i, t = !1, e = 0) {
    const r = this._$AH, n = this._$AN;
    if (void 0 !== n && 0 !== n.size) {
        if (t) {
            if (Array.isArray(r)) for(let i = e; i < r.length; i++)$f3bd3fa2e54a33fb$var$s(r[i], !1), $f3bd3fa2e54a33fb$var$o(r[i]);
            else null != r && ($f3bd3fa2e54a33fb$var$s(r, !1), $f3bd3fa2e54a33fb$var$o(r));
        } else $f3bd3fa2e54a33fb$var$s(this, i);
    }
}
const $f3bd3fa2e54a33fb$var$l = (i)=>{
    var t, s, o, r;
    i.type == (0, $3baabda811939da5$export$9ba3b3f20a85bfa).CHILD && (null !== (t = (o = i)._$AP) && void 0 !== t || (o._$AP = $f3bd3fa2e54a33fb$var$h), null !== (s = (r = i)._$AQ) && void 0 !== s || (r._$AQ = $f3bd3fa2e54a33fb$var$n));
};
class $f3bd3fa2e54a33fb$export$7d025501802325e extends (0, $3baabda811939da5$export$befdefbdce210f91) {
    constructor(){
        super(...arguments), this._$AN = void 0;
    }
    _$AT(i, t, e) {
        super._$AT(i, t, e), $f3bd3fa2e54a33fb$var$r(this), this.isConnected = i._$AU;
    }
    _$AO(i, t = !0) {
        var e, r;
        i !== this.isConnected && (this.isConnected = i, i ? null === (e = this.reconnected) || void 0 === e || e.call(this) : null === (r = this.disconnected) || void 0 === r || r.call(this)), t && ($f3bd3fa2e54a33fb$var$s(this, i), $f3bd3fa2e54a33fb$var$o(this));
    }
    setValue(t) {
        if ((0, $ead5767561d7cbc1$export$7f431ad0fff82fd9)(this._$Ct)) this._$Ct._$AI(t, this);
        else {
            const i = [
                ...this._$Ct._$AH
            ];
            i[this._$Ci] = t, this._$Ct._$AI(i, this, 0);
        }
    }
    disconnected() {}
    reconnected() {}
}



/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a71e39f8d7120011$export$7d1e3a5e95ceca43 = ()=>new $a71e39f8d7120011$var$o;
class $a71e39f8d7120011$var$o {
}
const $a71e39f8d7120011$var$h = new WeakMap, $a71e39f8d7120011$export$eff4d24c3ff7876e = (0, $3baabda811939da5$export$99b43ad1ed32e735)(class extends (0, $f3bd3fa2e54a33fb$export$7d025501802325e) {
    render(t) {
        return 0, $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    update(t, [s]) {
        var e;
        const o = s !== this.G;
        return o && void 0 !== this.G && this.ot(void 0), (o || this.rt !== this.lt) && (this.G = s, this.ct = null === (e = t.options) || void 0 === e ? void 0 : e.host, this.ot(this.lt = t.element)), $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    ot(i) {
        var t;
        if ("function" == typeof this.G) {
            const s = null !== (t = this.ct) && void 0 !== t ? t : globalThis;
            let e = $a71e39f8d7120011$var$h.get(s);
            void 0 === e && (e = new WeakMap, $a71e39f8d7120011$var$h.set(s, e)), void 0 !== e.get(this.G) && this.G.call(this.ct, void 0), e.set(this.G, i), void 0 !== i && this.G.call(this.ct, i);
        } else this.G.value = i;
    }
    get rt() {
        var i, t, s;
        return "function" == typeof this.G ? null === (t = $a71e39f8d7120011$var$h.get(null !== (i = this.ct) && void 0 !== i ? i : globalThis)) || void 0 === t ? void 0 : t.get(this.G) : null === (s = this.G) || void 0 === s ? void 0 : s.value;
    }
    disconnected() {
        this.rt === this.lt && this.ot(void 0);
    }
    reconnected() {
        this.ot(this.lt);
    }
});




/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3233927aa82734f9$var$t = window, $3233927aa82734f9$export$b4d10f6001c083c2 = $3233927aa82734f9$var$t.ShadowRoot && (void 0 === $3233927aa82734f9$var$t.ShadyCSS || $3233927aa82734f9$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $3233927aa82734f9$var$s = Symbol(), $3233927aa82734f9$var$n = new WeakMap;
class $3233927aa82734f9$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $3233927aa82734f9$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($3233927aa82734f9$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $3233927aa82734f9$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $3233927aa82734f9$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $3233927aa82734f9$export$8d80f9cac07cdb3 = (t)=>new $3233927aa82734f9$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $3233927aa82734f9$var$s), $3233927aa82734f9$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $3233927aa82734f9$export$505d1e8739bad805(n, t, $3233927aa82734f9$var$s);
}, $3233927aa82734f9$export$2ca4a66ec4cecb90 = (s, n)=>{
    $3233927aa82734f9$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $3233927aa82734f9$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $3233927aa82734f9$export$ee69dfd951e24778 = $3233927aa82734f9$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $3233927aa82734f9$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $27fcf98b67c2a783$var$s;
const $27fcf98b67c2a783$var$e = window, $27fcf98b67c2a783$var$r = $27fcf98b67c2a783$var$e.trustedTypes, $27fcf98b67c2a783$var$h = $27fcf98b67c2a783$var$r ? $27fcf98b67c2a783$var$r.emptyScript : "", $27fcf98b67c2a783$var$o = $27fcf98b67c2a783$var$e.reactiveElementPolyfillSupport, $27fcf98b67c2a783$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $27fcf98b67c2a783$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $27fcf98b67c2a783$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $27fcf98b67c2a783$var$l = {
    attribute: !0,
    type: String,
    converter: $27fcf98b67c2a783$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $27fcf98b67c2a783$export$53a6892c50694894
}, $27fcf98b67c2a783$var$d = "finalized";
class $27fcf98b67c2a783$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this.u();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $27fcf98b67c2a783$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $27fcf98b67c2a783$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($27fcf98b67c2a783$var$d)) return !1;
        this[$27fcf98b67c2a783$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $3233927aa82734f9$export$ee69dfd951e24778)(i));
        } else void 0 !== i && s.push((0, $3233927aa82734f9$export$ee69dfd951e24778)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    u() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $3233927aa82734f9$export$2ca4a66ec4cecb90)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $27fcf98b67c2a783$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $27fcf98b67c2a783$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $27fcf98b67c2a783$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $27fcf98b67c2a783$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$27fcf98b67c2a783$export$c7c07a37856565d[$27fcf98b67c2a783$var$d] = !0, $27fcf98b67c2a783$export$c7c07a37856565d.elementProperties = new Map, $27fcf98b67c2a783$export$c7c07a37856565d.elementStyles = [], $27fcf98b67c2a783$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $27fcf98b67c2a783$var$o || $27fcf98b67c2a783$var$o({
    ReactiveElement: $27fcf98b67c2a783$export$c7c07a37856565d
}), (null !== ($27fcf98b67c2a783$var$s = $27fcf98b67c2a783$var$e.reactiveElementVersions) && void 0 !== $27fcf98b67c2a783$var$s ? $27fcf98b67c2a783$var$s : $27fcf98b67c2a783$var$e.reactiveElementVersions = []).push("1.6.2");





/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $fe586ba0757c37f7$var$l, $fe586ba0757c37f7$var$o;
const $fe586ba0757c37f7$export$8bf27daf9e8907c9 = (0, $27fcf98b67c2a783$export$c7c07a37856565d);
class $fe586ba0757c37f7$export$3f2f9f5909897157 extends (0, $27fcf98b67c2a783$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $e5ed8027d647799b$export$9c068ae9cc5db4e8;
    }
}
$fe586ba0757c37f7$export$3f2f9f5909897157.finalized = !0, $fe586ba0757c37f7$export$3f2f9f5909897157._$litElement$ = !0, null === ($fe586ba0757c37f7$var$l = globalThis.litElementHydrateSupport) || void 0 === $fe586ba0757c37f7$var$l || $fe586ba0757c37f7$var$l.call(globalThis, {
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$var$n = globalThis.litElementPolyfillSupport;
null == $fe586ba0757c37f7$var$n || $fe586ba0757c37f7$var$n({
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($fe586ba0757c37f7$var$o = globalThis.litElementVersions) && void 0 !== $fe586ba0757c37f7$var$o ? $fe586ba0757c37f7$var$o : globalThis.litElementVersions = []).push("3.3.2");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $650ed036964a13b8$export$6acf61af03e62db = !1;




class $aef6bc0325599c03$export$c60dbe98c84a7c22 {
    context;
    gainNode;
    constructor(context){
        this.context = context;
        this.gainNode = new GainNode(context);
    }
    get currentTime() {
        return this.context.currentTime;
    }
    get volume() {
        return this.gainNode.gain.value;
    }
    set volume(value) {
        this.gainNode.gain.setValueAtTime(value, this.currentTime);
    }
}


class $6f7fc6163e81fd62$export$91bedb4806cd55f0 {
    static naturals = [
        0,
        2,
        4,
        5,
        7,
        9,
        11
    ];
    static accidentals = [
        1,
        3,
        6,
        8,
        10
    ];
    static names = [
        [
            "C"
        ],
        [
            "C♯",
            "D♭"
        ],
        [
            "D"
        ],
        [
            "D♯",
            "E♭"
        ],
        [
            "E"
        ],
        [
            "F"
        ],
        [
            "F♯",
            "G♭"
        ],
        [
            "G"
        ],
        [
            "G♯",
            "A♭"
        ],
        [
            "A"
        ],
        [
            "A♯",
            "B♭"
        ],
        [
            "B"
        ]
    ];
    static isNatural(noteNumber) {
        return this.naturals.includes($6f7fc6163e81fd62$export$842a2cf37af977e1(noteNumber, 12));
    }
    static isAccidental(noteNumber) {
        return this.accidentals.includes($6f7fc6163e81fd62$export$842a2cf37af977e1(noteNumber, 12));
    }
    static namesOf(noteNumber) {
        return this.names[$6f7fc6163e81fd62$export$842a2cf37af977e1(noteNumber, 12)];
    }
    static frequencyOf(noteZeroFrequency, noteNumber) {
        return noteZeroFrequency * Math.pow(2, noteNumber / 12);
    }
    noteZeroFrequency;
    noteNumber;
    constructor(noteZeroFrequency, noteNumber = 0){
        this.noteZeroFrequency = noteZeroFrequency;
        this.noteNumber = noteNumber;
    }
    get frequency() {
        return this.constructor.frequencyOf(this.noteZeroFrequency, this.noteNumber);
    }
    get names() {
        return this.constructor.namesOf(this.noteNumber);
    }
    plus(noteNumber) {
        return new this.constructor(this.noteZeroFrequency, noteNumber);
    }
}
function $6f7fc6163e81fd62$export$842a2cf37af977e1(a, b) {
    return (a % b + b) % b;
}



class $d9d3f77312c8bfda$export$cf6d3785672252c4 extends (0, $aef6bc0325599c03$export$c60dbe98c84a7c22) {
    gainEnvelope;
    oscillator;
    _wave;
    _note;
    startTime;
    stopTime;
    constructor(context, destinationNode, gainEnvelope, wave, note){
        super(context);
        this.gainEnvelope = gainEnvelope;
        this.oscillator = new OscillatorNode(context);
        this.wave = wave;
        this.note = note;
        this.startTime = -1;
        this.stopTime = -1;
        this.gainNode.connect(destinationNode);
        this.oscillator.connect(this.gainNode);
    }
    set wave(value) {
        this._wave = value;
        if (this._wave instanceof PeriodicWave) this.oscillator.setPeriodicWave(this._wave);
        else this.oscillator.type = this._wave;
    }
    get wave() {
        return this._wave;
    }
    get note() {
        return this._note;
    }
    set note(value) {
        this._note = value;
        this.oscillator.frequency.setValueAtTime(this._note.frequency, this.currentTime);
    }
    get started() {
        return this.startTime >= 0;
    }
    get stopped() {
        return this.stopTime >= 0;
    }
    get duration() {
        if (this.started) {
            const stopTime = this.stopped ? this.stopTime : this.currentTime;
            return stopTime - this.startTime;
        } else return -1;
    }
    start(startTime) {
        this.startTime = startTime;
        this.gainEnvelope.gate(this.gainNode.gain, this.startTime);
        this.oscillator.start(this.startTime);
    }
    stop(stopTime) {
        this.stopTime = stopTime;
        this.gainEnvelope.ungate(this.gainNode.gain, this.stopTime);
        this.oscillator.stop(Math.ceil(this.stopTime + this.gainEnvelope.releaseTime) + 1);
    }
    onStop(handler) {
        this.oscillator.addEventListener("ended", handler);
    }
}


class $148399bb97eda8a5$export$30c5e19407545686 extends (0, $aef6bc0325599c03$export$c60dbe98c84a7c22) {
    compressor;
    gainEnvelope;
    wave;
    noteZero;
    oscillators;
    constructor(gainEnvelope, wave, noteZeroFrequency){
        super(new AudioContext());
        this.compressor = new DynamicsCompressorNode(this.context);
        this.gainEnvelope = gainEnvelope;
        this.wave = wave;
        this.noteZero = new (0, $6f7fc6163e81fd62$export$91bedb4806cd55f0)(noteZeroFrequency);
        this.oscillators = [];
        this.compressor.connect(this.context.destination);
        this.gainNode.connect(this.compressor);
    }
    startOscillator(noteNumber, startTime) {
        startTime ||= this.currentTime;
        const oscillator = new (0, $d9d3f77312c8bfda$export$cf6d3785672252c4)(this.context, this.gainNode, this.gainEnvelope, this.wave, this.noteZero.plus(noteNumber));
        this.oscillators.push(oscillator);
        oscillator.start(startTime);
        return oscillator;
    }
    get noteZeroFrequency() {
        return this.noteZero.noteZeroFrequency;
    }
    set noteZeroFrequency(value) {
        this.noteZero.noteZeroFrequency = value;
    }
    stopOscillator(oscillator, stopTime) {
        if (this.oscillators.includes(oscillator)) {
            stopTime ??= this.currentTime;
            oscillator.onStop(()=>this.removeOscillator(oscillator));
            oscillator.stop(stopTime);
        }
    }
    removeOscillator(oscillator) {
        const index = this.oscillators.indexOf(oscillator);
        if (index >= 0) this.oscillators.splice(index, 1);
    }
}


/**
 *     Delay Attack Decay Sustain Release
 *   ^      .      .     .       .
 * A |      .      .     .       .
 * m |      .      .     .       .
 * p |      .      .     .       .
 * l |      .     / \_   .       .
 * i |      .    /    \_ .       .
 * t |      .   /       \._______.
 * u |      .  /                  \__
 * d |      . /                      \__
 * e | _____./                          \
 *   +------------------------------------>
 *     Time
 */ class $6e1a3bb978d1d60c$export$4ae0ea4bf419042e {
    delayTime;
    minimumAmplitude;
    attackTime;
    maximumAmplitude;
    decayTime;
    sustainAmplitude;
    releaseTime;
    constructor(delayTime = 0, minimumAmplitude = 0, attackTime = 0, maximumAmplitude = 1, decayTime = 0, sustainAmplitude = 1, releaseTime = 0){
        this.delayTime = delayTime;
        this.minimumAmplitude = minimumAmplitude;
        this.attackTime = attackTime;
        this.maximumAmplitude = maximumAmplitude;
        this.decayTime = decayTime;
        this.sustainAmplitude = sustainAmplitude;
        this.releaseTime = releaseTime;
    }
    delay(audioParam, time, amplitude = 1) {
        audioParam.cancelScheduledValues(time);
        audioParam.setValueAtTime(this.minimumAmplitude * amplitude, time);
    }
    attack(audioParam, time, amplitude = 1) {
        audioParam.cancelScheduledValues(time);
        audioParam.setTargetAtTime(this.maximumAmplitude * amplitude, time, this.attackTime);
    }
    decay(audioParam, time, amplitude = 1) {
        audioParam.cancelScheduledValues(time);
        audioParam.setTargetAtTime(this.sustainAmplitude * amplitude, time, this.decayTime);
    }
    release(audioParam, time, amplitude = 1) {
        audioParam.cancelScheduledValues(time);
        audioParam.setTargetAtTime(this.minimumAmplitude * amplitude, time, this.releaseTime);
    }
    gate(audioParam, time, amplitude = 1) {
        this.delay(audioParam, time, amplitude);
        time += this.delayTime;
        this.attack(audioParam, time, amplitude);
        time += this.attackTime;
        this.decay(audioParam, time, amplitude);
    }
    ungate(audioParam, time, amplitude = 1) {
        this.release(audioParam, time, amplitude);
    }
}








function $853244f1895efe1f$export$c9fc3ccebcc4888d(logicalRect, inlineOffset, blockOffset) {
    const inline = logicalRect.inlineStart + (logicalRect.inlineEnd - logicalRect.inlineStart) * inlineOffset;
    const block = logicalRect.blockStart + (logicalRect.blockEnd - logicalRect.blockStart) * blockOffset;
    return {
        inline: inline,
        block: block
    };
}


function $d69cf5af31eb3347$export$45f7c413bf95be53(element) {
    const style = getComputedStyle(element);
    const { writingMode: writingMode, direction: direction } = style;
    let x;
    let y;
    let left;
    let right;
    let top;
    let bottom;
    let width;
    let height;
    if (writingMode.startsWith("horizontal")) {
        x = "inline";
        width = "inlineSize";
        y = "block";
        height = "blockSize";
        if (direction === "ltr") {
            left = "inlineStart";
            right = "inlineEnd";
        } else /* if (direction === 'rtl') */ {
            right = "inlineStart";
            left = "inlineEnd";
        }
        if (writingMode.endsWith("-tb")) {
            top = "blockStart";
            bottom = "blockEnd";
        } else /* if (writingMode.endsWith('-bt')) */ {
            bottom = "blockStart";
            top = "blockEnd";
        }
    } else /* if (writingMode.startsWith('vertical')) */ {
        y = "inline";
        height = "inlineSize";
        x = "block";
        width = "blockSize";
        if (direction === "ltr") {
            top = "inlineStart";
            bottom = "inlineEnd";
        } else /* if (direction === 'rtl') */ {
            bottom = "inlineStart";
            top = "inlineEnd";
        }
        if (writingMode.endsWith("-rl")) {
            right = "blockStart";
            left = "blockEnd";
        } else /* if (writingMode.endsWith('-lr')) */ {
            left = "blockStart";
            right = "blockEnd";
        }
    }
    return {
        x: x,
        y: y,
        left: left,
        right: right,
        top: top,
        bottom: bottom,
        width: width,
        height: height
    };
}


function $56fba2e447cc2a03$export$8c410beac1c9994(element) {
    const writingDirection = (0, $d69cf5af31eb3347$export$45f7c413bf95be53)(element);
    const physicalRect = element.getBoundingClientRect();
    const logicalRect = {
        physicalRect: physicalRect,
        writingDirection: writingDirection
    };
    for (const direction of [
        "left",
        "right",
        "top",
        "bottom",
        "width",
        "height"
    ])logicalRect[writingDirection[direction]] = physicalRect[direction];
    return logicalRect;
}





class $9f065ae4482b26ac$export$4d20f3f94403c017 extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    static tagName = "ui-modal";
    static properties = {
        closeEvent: {
            type: String,
            attribute: "close-event",
            reflect: true
        },
        parent: {
            type: Element
        },
        parentInlineOffset: {
            type: Number,
            attribute: "i0",
            reflect: true
        },
        parentBlockOffset: {
            type: Number,
            attribute: "b0",
            reflect: true
        },
        inlineOffset: {
            type: Number,
            attribute: "i1",
            reflect: true
        },
        blockOffset: {
            type: Number,
            attribute: "b1",
            reflect: true
        }
    };
    /**
	 * Left-to-right, top-to-bottom
	 *       Inline
	 *       0 ... 0.5 ... 1
	 * B   0 +------+------+
	 * l ... |             |
	 * o 0.5 +      +      +
	 * c ... |             |
	 * k   1 +------+------+
	 */ constructor(){
        super();
        this.closeEvent = "close";
        this.parent = this.parentElement || document.body;
        this.parentInlineOffset = 0;
        this.parentBlockOffset = 1;
        this.inlineOffset = 0;
        this.blockOffset = 0;
        this.resizeObserver = new ResizeObserver(this.reposition);
    }
    disconnectedCallback() {
        this.resizeObserver.unobserve(this.parent);
    }
    firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.parent);
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        this.reposition();
    }
    reposition = ()=>{
        if (this.parent instanceof Element) {
            this.style.transform = "";
            const bodyRect = (0, $56fba2e447cc2a03$export$8c410beac1c9994)(document.body);
            const parentRect = (0, $56fba2e447cc2a03$export$8c410beac1c9994)(this.parent);
            const rect = (0, $56fba2e447cc2a03$export$8c410beac1c9994)(this);
            const { inline: i0, block: b0 } = (0, $853244f1895efe1f$export$c9fc3ccebcc4888d)(parentRect, this.parentInlineOffset, this.parentBlockOffset);
            const { inline: i1, block: b1 } = (0, $853244f1895efe1f$export$c9fc3ccebcc4888d)(rect, this.inlineOffset, this.blockOffset);
            let inlineOffset = i0 - i1;
            let blockOffset = b0 - b1;
            /**
			 *         T
			 *   +-----------+
			 *   |     t     |
			 *   |   +---+   |
			 * L | l |   | r | R
			 *   |   +---+   |
			 *   |     b     |
			 *   +-----------+
			 *         B
			 */ // assert r < R
            if (rect.inlineEnd + inlineOffset > bodyRect.inlineEnd) inlineOffset = bodyRect.inlineEnd - rect.inlineEnd;
            // assert b < B
            if (rect.blockEnd + blockOffset > bodyRect.blockEnd) blockOffset = bodyRect.blockEnd - rect.blockEnd;
            // assert l > L
            if (rect.inlineStart + inlineOffset < bodyRect.inlineStart) inlineOffset = -rect.inlineStart;
            // assert t > T
            if (rect.blockStart + blockOffset < bodyRect.blockStart) blockOffset = -rect.blockStart;
            const inline = rect.writingDirection.x === "inline" ? "X" : "Y";
            const block = rect.writingDirection.y === "block" ? "Y" : "X";
            this.style.transform = `translate${inline}(${inlineOffset}px) translate${block}(${blockOffset}px)`;
        }
    };
    close() {
        this.dispatchEvent(new CustomEvent(this.closeEvent, {
            bubbles: true
        }));
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
			<div part='grid'>
				<div part='head'>
					<span part='title'>
						<slot name='title'></slot>
					</span>
					<button part='close-button' type='button' @click='${this.close}'>
						<slot name='close-button'>✖</slot>
					</button>
				</div>
				<div part='body'>
					<slot name='body'></slot>
				</div>
			</div>
		`;
    }
    static styles = (0, $3233927aa82734f9$export$dbf350e5966cf602)`
		:host {
			display: block;
			position: absolute;
			z-index: 1;
		}

		[part='grid'] {
			background: white;
			border-radius: 0.25em;
			box-shadow: 0 0.25em 0.5em rgba(0, 0, 0, 0.3), 0 0.5em 1em rgba(0, 0, 0, 0.2), 0 1em 2em rgba(0, 0, 0, 0.1);
			color: black;
			overflow: auto;
		}

		[part='head'] {
			align-items: center;
			border-block-end: thin solid rgba(0, 0, 0, 0.2);
			display: grid;
			font-size: 0.8em;
			grid-template-columns: 1fr auto;
		}

		[part='close-button'] {
			all: unset;
			user-select: none;
		}

		[part='title'], [part='close-button'], [part='body'] {
			padding: 1em;
		}

		[part='title'] {
			font-weight: bold;
		}

		[part='close-button']:hover, [part='close-button']:focus {
			background: rgba(0, 0, 0, 0.1);
		}

		[part='close-button']:active {
			background: rgba(0, 0, 0, 0.2);
		}
	`;
}
customElements.define($9f065ae4482b26ac$export$4d20f3f94403c017.tagName, $9f065ae4482b26ac$export$4d20f3f94403c017);



class $19b95691eee81ed7$export$9f03a38f0155db8a extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    static tagName = "ui-toggle";
    static properties = {
        visible: {
            type: Boolean,
            reflect: true
        }
    };
    constructor(){
        super();
        this.visible = false;
    }
    firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
        this.addEventListener("close", this.closeHandler);
    }
    checkPath = (event)=>{
        const path = event.composedPath();
        const within = path.includes(this);
        !within && this.toggle();
    };
    toggle(visible) {
        this.visible = visible ?? !this.visible;
        if (this.visible) document.body.addEventListener("pointerdown", this.checkPath);
        else document.body.removeEventListener("pointerdown", this.checkPath);
    }
    close() {
        this.toggle(false);
    }
    clickHandler() {
        this.toggle();
    }
    closeHandler(event) {
        event.stopPropagation();
        this.close();
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
			<slot @click='${this.clickHandler}'></slot>
			${this.visible ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<slot name='toggled'></slot>` : (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
		`;
    }
}
customElements.define($19b95691eee81ed7$export$9f03a38f0155db8a.tagName, $19b95691eee81ed7$export$9f03a38f0155db8a);




var $c885d24a927270d4$exports = {};

$parcel$export($c885d24a927270d4$exports, "PianoKeyboard", () => $c885d24a927270d4$export$5581ec00194cd222);



/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $74d80410d825d70d$var$i = "important", $74d80410d825d70d$var$n = " !" + $74d80410d825d70d$var$i, $74d80410d825d70d$export$1e5b4ce2fa884e6a = (0, $3baabda811939da5$export$99b43ad1ed32e735)(class extends (0, $3baabda811939da5$export$befdefbdce210f91) {
    constructor(t){
        var e;
        if (super(t), t.type !== (0, $3baabda811939da5$export$9ba3b3f20a85bfa).ATTRIBUTE || "style" !== t.name || (null === (e = t.strings) || void 0 === e ? void 0 : e.length) > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return Object.keys(t).reduce((e, r)=>{
            const s = t[r];
            return null == s ? e : e + `${r = r.includes("-") ? r : r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${s};`;
        }, "");
    }
    update(e, [r]) {
        const { style: s } = e.element;
        if (void 0 === this.ut) {
            this.ut = new Set;
            for(const t in r)this.ut.add(t);
            return this.render(r);
        }
        this.ut.forEach((t)=>{
            null == r[t] && (this.ut.delete(t), t.includes("-") ? s.removeProperty(t) : s[t] = "");
        });
        for(const t in r){
            const e = r[t];
            if (null != e) {
                this.ut.add(t);
                const r = "string" == typeof e && e.endsWith($74d80410d825d70d$var$n);
                t.includes("-") || r ? s.setProperty(t, r ? e.slice(0, -11) : e, r ? $74d80410d825d70d$var$i : "") : s[t] = e;
            }
        }
        return 0, $e5ed8027d647799b$export$9c068ae9cc5db4e8;
    }
});






var $abbd6d945deee9ab$exports = {};

$parcel$export($abbd6d945deee9ab$exports, "PianoKey", () => $abbd6d945deee9ab$export$c852d403db3836b6);


class $abbd6d945deee9ab$export$c852d403db3836b6 extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    static tagName = "piano-key";
    static properties = {
        noteNumber: {
            type: Number,
            attribute: "note-number",
            reflect: true
        },
        key: {
            type: String,
            reflect: true
        },
        labelSource: {
            type: String,
            attribute: "label-source",
            reflect: true
        }
    };
    constructor(){
        super();
        this.noteNumber = 0;
        this.key = "";
        this.labelSource = "names";
    }
    firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
    }
    get natural() {
        return (0, $6f7fc6163e81fd62$export$91bedb4806cd55f0).isNatural(this.noteNumber);
    }
    get accidental() {
        return (0, $6f7fc6163e81fd62$export$91bedb4806cd55f0).isAccidental(this.noteNumber);
    }
    get names() {
        return (0, $6f7fc6163e81fd62$export$91bedb4806cd55f0).namesOf(this.noteNumber);
    }
    start(event) {
        if (event.buttons === 1) {
            event.currentTarget.focus();
            event.target.releasePointerCapture(event.pointerId);
            this.dispatchEvent(new KeyboardEvent("keydown", {
                composed: true,
                key: this.key
            }));
        }
    }
    stop() {
        this.dispatchEvent(new KeyboardEvent("keyup", {
            composed: true,
            key: this.key
        }));
    }
    renderNames() {
        return this.names.map(this.renderLabel);
    }
    renderLabel(label) {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
			<span part='label'>
				${label}
			</span>
		`;
    }
    renderLabels() {
        switch(this.labelSource){
            case "names":
                return this.renderNames();
            case "key":
                return this.renderLabel(this.key.substring(0, 3));
            default:
                return "";
        }
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
			<button class='key ${this.natural ? "natural" : "accidental"}' type='button' tabindex='-1'
				@pointerdown='${this.start}'
				@pointerup='${this.stop}'
				@pointerenter='${this.start}'
				@pointerleave='${this.stop}'
			>
				<span part='labels'>
					${this.renderLabels()}
				</span>
			</button>
		`;
    }
    static styles = (0, $3233927aa82734f9$export$dbf350e5966cf602)`
		:host {
			display: block;
		}

		.key {
			all: unset;
			user-select: none;
		}

		.key, [part='labels'] {
			block-size: 100%;
			box-sizing: border-box;
			inline-size: 100%;
		}

		.natural {
			--background: white;
			--border-color: hsl(0, 0%, 30%);
			--font-size: 1em;
			--text-color: black;
		}

		.accidental {
			--background: hsl(0, 0%, 10%);
			--border-color: hsl(0, 0%, 30%);
			--font-size: 0.8em;
			--text-color: white;
		}

		[part='labels'] {
			align-items: end;
			background: var(--background);
			border-radius: 0.25em;
			border: 0.0625em solid var(--border-color);
			box-shadow: 0 0.125em 0.0625em rgba(0, 0, 0, 0.3), 0 0.25em 0.125em rgba(0, 0, 0, 0.2), 0 0.5em 0.25em rgba(0, 0, 0, 0.1);
			color: var(--text-color);
			display: grid;
			font-size: var(--font-size);
			grid-template-rows: 1fr auto;
			justify-items: center;
			padding: 0.5em;
			pointer-events: none;
			transition: transform 0.125s;
		}

		:host([down]) [part='labels'] {
			transform: translateY(0.5em);
			transition: none;
		}
	`;
}
customElements.define($abbd6d945deee9ab$export$c852d403db3836b6.tagName, $abbd6d945deee9ab$export$c852d403db3836b6);


class $c885d24a927270d4$export$5581ec00194cd222 extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    static tagName = "piano-keyboard";
    static dependencies = [
        (0, $abbd6d945deee9ab$export$c852d403db3836b6)
    ];
    static properties = {
        synthesizer: {
            type: (0, $148399bb97eda8a5$export$30c5e19407545686)
        },
        minimumNoteDuration: {
            type: Number,
            attribute: "minimum-note-duration",
            reflect: true
        },
        labelSource: {
            type: String,
            attribute: "label-source",
            reflect: true
        }
    };
    constructor(){
        super();
        this.synthesizer = null;
        this.minimumNoteDuration = 0.2;
        this.labelSource = "names";
        this.keyToNoteNumberMap = (0, $16f4c57bdee1fbda$export$4c08613943e86cca).QWERTY;
        this.keyToOscillatorMap = new Map();
    }
    firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
        this.addEventListener("keydown", this.keyDownListener);
        this.addEventListener("keyup", this.keyUpListener);
        this.addEventListener("blur", this.blurListener);
    }
    startOscillator(key) {
        if (this.synthesizer instanceof (0, $148399bb97eda8a5$export$30c5e19407545686) && !this.keyToOscillatorMap.has(key)) {
            const noteNumber = this.keyToNoteNumberMap.get(key);
            if (typeof noteNumber === "number") {
                const oscillator = this.synthesizer.startOscillator(noteNumber, this.synthesizer.currentTime);
                this.keyToOscillatorMap.set(key, oscillator);
                this.requestUpdate();
                return true;
            }
        }
        return false;
    }
    stopOscillator(key) {
        const oscillator = this.keyToOscillatorMap.get(key);
        if (this.synthesizer instanceof (0, $148399bb97eda8a5$export$30c5e19407545686) && oscillator instanceof (0, $d9d3f77312c8bfda$export$cf6d3785672252c4)) {
            const stopTime = this.synthesizer.currentTime + Math.max(0, this.minimumNoteDuration - oscillator.duration);
            this.synthesizer.stopOscillator(oscillator, stopTime);
            this.keyToOscillatorMap.delete(key);
            this.requestUpdate();
            return true;
        }
        return false;
    }
    stopAllOscillators() {
        if (this.synthesizer instanceof (0, $148399bb97eda8a5$export$30c5e19407545686)) {
            for (const [key, oscillator] of this.keyToOscillatorMap){
                this.synthesizer.stopOscillator(oscillator);
                this.keyToOscillatorMap.delete(key);
            }
            this.requestUpdate();
        }
    }
    keyDownListener(event) {
        if (!(event.ctrlKey || event.altKey || event.shiftKey)) this.startOscillator(event.key) && event.preventDefault();
    }
    keyUpListener(event) {
        if (!(event.ctrlKey || event.altKey || event.shiftKey)) this.stopOscillator(event.key) && event.preventDefault();
    }
    blurListener() {
        this.stopAllOscillators();
    }
    renderKey(key, noteNumber) {
        const row = Math.floor(noteNumber / 12) * 2;
        let rowSpan;
        let column = noteNumber % 12;
        let zIndex;
        if ((0, $6f7fc6163e81fd62$export$91bedb4806cd55f0).isNatural(column)) {
            if (column >= 5) column += 1;
            rowSpan = 2;
            zIndex = row;
        } else {
            if (column >= 6) column += 1;
            rowSpan = 1;
            zIndex = row + 1;
        }
        const style = (0, $74d80410d825d70d$export$1e5b4ce2fa884e6a)({
            gridRowStart: String(8 - row - 1),
            gridRowEnd: `span ${rowSpan}`,
            gridColumnStart: String(column + 1),
            gridColumnEnd: "span 2",
            zIndex: String(zIndex)
        });
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
			<piano-key note-number=${noteNumber} key='${key}' ?down='${this.keyToOscillatorMap.has(key)}' label-source='${this.labelSource}' style='${style}'></piano-key>
		`;
    }
    renderKeys() {
        const results = [];
        for (const [key, noteNumber] of this.keyToNoteNumberMap)results.push(this.renderKey(key, noteNumber));
        return results;
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
			<div part='grid'>
				${this.renderKeys()}
			</div>
		`;
    }
    static styles = (0, $3233927aa82734f9$export$dbf350e5966cf602)`
		:host {
			display: block;
			touch-action: none;
		}

		[part='grid'] {
			block-size: 100%;
			box-sizing: border-box;
			display: grid;
			grid-template-columns: repeat(14, 1fr);
			grid-template-rows: repeat(8, 1fr);
			inline-size: 100%;
			padding-block-end: 0.75em;
			padding-block-start: 0.125em;
			padding-inline: 0.25em;
			transition: opacity 0.125s;
		}

		:host(:not(:focus):not(:focus-within)) [part='grid'] {
			opacity: 0.5;
		}
	`;
}
customElements.define($c885d24a927270d4$export$5581ec00194cd222.tagName, $c885d24a927270d4$export$5581ec00194cd222);


const $4750f8427600f904$var$defaultGainEnvelope = Object.freeze(new (0, $6e1a3bb978d1d60c$export$4ae0ea4bf419042e)(0, 0, 0.1, 1, 0.1, 0.8, 0.1));
class $4750f8427600f904$export$ff5339764f77153d extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    static tagName = "piano-app";
    static version = "1.1.4";
    static dependencies = [
        (0, $c885d24a927270d4$export$5581ec00194cd222),
        (0, $9f065ae4482b26ac$export$4d20f3f94403c017),
        (0, $19b95691eee81ed7$export$9f03a38f0155db8a)
    ];
    static waves = [
        [
            "sine",
            "Sine"
        ],
        [
            "square",
            "Square"
        ],
        [
            "sawtooth",
            "Sawtooth"
        ],
        [
            "triangle",
            "Triangle"
        ],
        [
            "flute",
            "Flute"
        ]
    ];
    static frequencies = [
        [
            "27.50000",
            "27.50 Hz (A0)"
        ],
        [
            "32.70320",
            "32.70 Hz (C1)"
        ],
        [
            "55.00000",
            "55.00 Hz (A1)"
        ],
        [
            "65.40639",
            "65.40 Hz (C2)"
        ],
        [
            "110.0000",
            "110.0 Hz (A2)"
        ],
        [
            "130.8128",
            "130.8 Hz (C3)"
        ],
        [
            "220.0000",
            "220.0 Hz (A3)"
        ],
        [
            "261.6256",
            "261.6 Hz (C4)"
        ]
    ];
    static keyLabelSources = [
        [
            "names",
            "Note Names"
        ],
        [
            "key",
            "Keyboard Shortcuts"
        ],
        [
            "none",
            "None (Hide)"
        ]
    ];
    static properties = {
        wave: {
            type: String,
            reflect: true
        },
        frequencyString: {
            type: String,
            attribute: "frequency",
            reflect: true
        },
        volume: {
            type: Number,
            reflect: true
        },
        minimumNoteDuration: {
            type: Number,
            attribute: "minimum-note-duration",
            reflect: true
        },
        keyLabelSource: {
            type: String,
            attribute: "key-label-source",
            reflect: true
        }
    };
    constructor(){
        super();
        this.wave = "triangle";
        this.frequencyString = "130.8128";
        this.volume = 1;
        this.gainEnvelope = $4750f8427600f904$var$defaultGainEnvelope;
        this.synthesizer = new (0, $148399bb97eda8a5$export$30c5e19407545686)(this.gainEnvelope, this.wave, this.frequency);
        this.minimumNoteDuration = 0.25;
        this.keyLabelSource = "names";
        this.keyboardRef = (0, $a71e39f8d7120011$export$7d1e3a5e95ceca43)();
    }
    get frequency() {
        return Number(this.frequencyString);
    }
    get keyboard() {
        return this.keyboardRef.value;
    }
    firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
        this.keyboard.focus();
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has("wave")) {
            if (this.wave === "flute") {
                this.synthesizer.wave = "triangle";
                this.gainEnvelope = new (0, $6e1a3bb978d1d60c$export$4ae0ea4bf419042e)(0.1, 0, 0.1, 0.8, 0.1, 0.4, 0.15);
                this.synthesizer.gainEnvelope = this.gainEnvelope;
            } else {
                this.synthesizer.wave = this.wave;
                this.gainEnvelope = $4750f8427600f904$var$defaultGainEnvelope;
                this.synthesizer.gainEnvelope = this.gainEnvelope;
            }
        }
        if (changedProperties.has("volume")) this.synthesizer.volume = this.volume;
        if (changedProperties.has("frequencyString")) this.synthesizer.noteZeroFrequency = this.frequency;
    }
    setWave(event) {
        this.wave = event.target.value;
    }
    setFrequency(event) {
        this.frequencyString = event.target.value;
    }
    setVolume(event) {
        this.volume = Number(event.currentTarget.value);
    }
    setKeyLabelSource(event) {
        this.keyLabelSource = event.target.value;
    }
    renderOption(selectedValue) {
        return ([value, label])=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
			<option value='${value}' ?selected='${value === selectedValue}'>
				${label}
			</option>
		`;
    }
    renderSelect(options, inputHandler, selectedValue) {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
			<select part='input' @input='${inputHandler}'>
				${options.map(this.renderOption(selectedValue))}
			</select>
		`;
    }
    renderInstrumentSettings() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
			<ui-toggle>
				<button type='button' class='menu-item'>
					🎹
				</button>
				<ui-modal slot='toggled'>
					<span slot='title'>Instrument</span>
					<div part='form' slot='body'>
						<label part='input-group'>
							<span part='input-label'>
								Wave
							</span>
							${this.renderSelect(this.constructor.waves, this.setWave, this.wave)}
						</label>
						<label part='input-group'>
							<span part='input-label'>
								C<sub>0</sub> Frequency
							</span>
							${this.renderSelect(this.constructor.frequencies, this.setFrequency, this.frequencyString)}
						</label>
					</div>
				</ui-modal>
			</ui-toggle>
		`;
    }
    renderVolumeSlider() {
        let icon;
        if (this.volume >= 2 / 3) icon = "\uD83D\uDD0A";
        else if (this.volume > 0) icon = "\uD83D\uDD09";
        else icon = "\uD83D\uDD08";
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
			<ui-toggle>
				<button type='button' class='menu-item'>
					${icon}
				</button>
				<ui-modal slot='toggled'>
					<span slot='title'>Volume</span>
					<div part='form' slot='body'>
						<input part='volume-slider' type='range' min='0' max='1' step='0.1' .value='${this.volume}'
							@input='${this.setVolume}' />
					</div>
				</ui-modal>
			</ui-toggle>
		`;
    }
    renderSettings() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
			<ui-toggle>
				<button type='button' class='menu-item'>⚙️</button>
				<ui-modal slot='toggled' i0='1' b0='1' i1='1' b1='0'>
					<span slot='title'>Settings</span>
					<div part='form' slot='body'>
						<label part='input-group'>
							<span part='input-label'>
								Key Labels From
							</span>
							${this.renderSelect(this.constructor.keyLabelSources, this.setKeyLabelSource, this.keyLabelSource)}
						</label>
					</div>
				</ui-modal>
			</ui-toggle>
		`;
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
			<div class='grid'>
				<div class='menu'>
					${this.renderInstrumentSettings()}
					${this.renderVolumeSlider()}
					<span aria-hidden='true'></span>
					${this.renderSettings()}
				</div>
				<piano-keyboard ${(0, $a71e39f8d7120011$export$eff4d24c3ff7876e)(this.keyboardRef)} .synthesizer='${this.synthesizer}'
					minimum-note-duration='${this.minimumNoteDuration}' label-source='${this.keyLabelSource}' tabindex='0'>
				</piano-keyboard>
			</div>
		`;
    }
    static styles = (0, $3233927aa82734f9$export$dbf350e5966cf602)`
		:host {
			display: block;
		}

		.grid {
			block-size: 100%;
			display: grid;
			grid-template-rows: auto 1fr;
			inline-size: 100%;
		}

		.menu {
			color: white;
			display: grid;
			grid-template-columns: auto auto 1fr auto;
			padding-block-end: 0.125em;
			padding-block-start: 0.25em;
			padding-inline: 0.25em;
		}

		.menu-item {
			all: unset;
			box-sizing: border-box;
			inline-size: 100%;
			padding-block: 0.5em;
			padding-inline: 0.75em;
		}

		.menu-item:hover {
			background: gray;
			border-radius: 0.25em;
			user-select: none;
		}

		[part='form'] {
			display: grid;
			gap: 1em;
		}

		[part='input-group'] {
			display: block;
		}

		[part='input-label'] {
			display: block;
			margin-block-end: 0.25em;
		}

		[part='input'] {
			font-size: 0.875em;
			padding: 0.5em;
		}

		[part='volume-slider'] {
			inline-size: 10em;
		}
	`;
}
customElements.define($4750f8427600f904$export$ff5339764f77153d.tagName, $4750f8427600f904$export$ff5339764f77153d);




$parcel$exportWildcard($dbcf4b4d170a8f34$exports, $16f4c57bdee1fbda$exports);
$parcel$exportWildcard($dbcf4b4d170a8f34$exports, $4750f8427600f904$exports);
$parcel$exportWildcard($dbcf4b4d170a8f34$exports, $abbd6d945deee9ab$exports);
$parcel$exportWildcard($dbcf4b4d170a8f34$exports, $c885d24a927270d4$exports);


//# sourceMappingURL=index.0d7bad8d.js.map
